import styled from 'styled-components';
import { TagOverride } from './StatusLayer/StatusLayer.style';
import { ContentWrapper } from './MiniScoreboardGame.style';
import { DataWrapper, OuterWrapper, NameWrapper, MobileRecordWrapper, DesktopRecordWrapper, FavIconContainer } from '@mlb/react-patterns/v4/components/Team/team.style';
import { ImageWrapper } from '@mlb/react-patterns/v4/components/Image/image.style';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';
import { GameDataLayerContentWrapper, GameDataLayerWrapper } from './GameDataLayer/GameDataLayer.style';

const { mlbGrey5, mlbGrey2 } = COLORS;

export const StatusLayerContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`;

export const ContentWrapperOverride = styled(ContentWrapper)`
    border-radius: 0;
    min-width: ${({ theme }) => theme?.contentWrapper?.width};
    height: ${({ theme }) => theme?.contentWrapper?.height};
    width: auto;

    @media (hover: hover) {
        &:hover {
            ${({ disableCell }) => !disableCell ? `border-color: ${mlbGrey2} !important;` : ''}
        }
    }

    ${TagOverride} {
        height: 12px !important;
        display: block !important;

        &.right {
            border-radius: 0px 0px 0px 5px;
        }
    }
`;

export const TeamMatchupWrapper = styled.div`
    display:flex;
    justify-content: center;
    ${DataWrapper} {
        margin-right: 8px;
    }
`;

export const TeamWrapper = styled.div`
    width: 76px;
    min-width: 76px;
    ${OuterWrapper} {
        width: 76px;
    }

    ${DataWrapper} {
        min-width: 38px;
        margin-top: 2px;
    }

    &.away {
        ${DataWrapper} {
            margin-right: 8px;
        }

        ${NameWrapper} {
            display: block;
        }

        ${FavIconContainer} {
            right: 0;
            bottom: 0;
            top: auto;
            left: auto;
        }

    }

    &.home {
        ${OuterWrapper} {
            margin-left: 0px;
        }

        ${DataWrapper} {
            margin-left: 8px;
            margin-right: 0px;
        }

        ${FavIconContainer} {
            top: -3px;
            left: -21px;
        }
        

    }

    ${MobileRecordWrapper} {
        font-size: 12px;
        white-space: nowrap;
    }

    ${DesktopRecordWrapper} {
        white-space: nowrap;
    }

    ${ImageWrapper} {
        height: ${({ theme }) => theme?.size};
        img {
            margin-top: 0;
            max-width: fit-content;
        }
    }
`;

export const ScoreWrapper = styled.div`
    text-align: center;
    display: flex;
    flex-direction: row;
    height: ${({ theme }) => theme?.size};
    line-height: ${({ theme }) => theme?.size};
    font-weight: 700;
    width: calc(100% - ${({ theme }) => theme?.scoreWrapperPadding});
`;

export const TeamScoreWrapper = styled.div`
    text-align: center;
    width: 60.5px;
    font-size: ${({ theme }) => theme?.size};
    flex: 1;
`;

export const GameInfoWrapper = styled.div`
    width: 80px;
    font-size: 12px;
    text-transform: uppercase;
    line-height: normal;
    position: relative;
    text-align: center;
    white-space: nowrap;

    ${GameDataLayerWrapper} {
        &:before {
            content: '';
            position: static;
            width: 0;
            height: 0;
            background-color: transparent;
        }
    }

    ${GameDataLayerContentWrapper} {
        position: static;
        transform: none;
        width: auto;
        margin-left: 0;
    }
`;

export const InfoWrapper = styled.div`
    margin: 0;
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
`;

export const SubLabelWrapper = styled.div`
    color: ${mlbGrey5};
    width: 100%;
`;
